import { render, staticRenderFns } from "./ajax-form.vue?vue&type=template&id=d93cdce2&"
import script from "./ajax-form.vue?vue&type=script&lang=js&"
export * from "./ajax-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports